import CityPageTemplate from './CityPageTemplate';

const cityData = {
  cityName: "Maplewood",
  metaDescription: "Expert plumber in Maplewood, MN. Bruce Nelson Plumbing & Heating offers fast, reliable plumbing and heating services. Call 651-738-9354 for service.",
  heroTitle: "Plumber in Maplewood, MN",
  heroSubtitle: "Trusted plumbing solutions for Maplewood homes and businesses.",
  introduction: "Maplewood homeowners and businesses count on Bruce Nelson Plumbing & Heating for professional plumbing services. Just minutes from our Oakdale headquarters, Maplewood is one of our most-served communities. From the Maplewood Mall area to the quiet residential streets, we're ready to handle any plumbing challenge.",
  services: [
    {
      title: "Residential Plumbing",
      description: "Full-service plumbing for Maplewood homes, from repairs to remodels.",
      link: "/services/residential"
    },
    {
      title: "Commercial Plumbing",
      description: "Reliable commercial plumbing for Maplewood businesses.",
      link: "/services/commercial"
    },
    {
      title: "Boiler Service",
      description: "Expert boiler services to keep Maplewood homes warm all winter.",
      link: "/services/boilers"
    },
    {
      title: "Water Heater Repair",
      description: "Fast water heater repair and installation in Maplewood.",
      link: "/services/water-heaters"
    },
    {
      title: "Bathroom Remodeling",
      description: "Transform your Maplewood bathroom with our expert team.",
      link: "/services/remodeling"
    },
    {
      title: "Sump Pump Service",
      description: "Sump pump installation and repair for Maplewood basements.",
      link: "/services"
    }
  ],
  whyChooseUs: [
    "Located just minutes from Maplewood",
    "Serving the community since 1976",
    "Fully licensed, bonded, and insured",
    "Know Maplewood homes and their plumbing needs",
    "No-surprise pricing on every job",
    "Quick response to all Maplewood service calls"
  ],
  serviceAreas: [
    { name: "Saint Paul", link: "/plumber-saint-paul" },
    { name: "Oakdale", link: "/plumber-oakdale" },
    { name: "Woodbury", link: "/plumber-woodbury" },
    { name: "Lake Elmo", link: "/plumber-lake-elmo" },
    { name: "Minneapolis", link: "/plumber-minneapolis" },
    { name: "Newport", link: "/plumber-newport" }
  ],
  testimonial: {
    text: "We've used BNPH for years in Maplewood. Always professional, always fair. They're the only plumber we call!",
    author: "Linda P."
  }
};

const MaplewoodPage = () => <CityPageTemplate cityData={cityData} />;

export default MaplewoodPage;
